var _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerSignal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1459_1889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 0C33.6739 0 32.4021 0.526784 31.4645 1.46447C30.5268 2.40215 30 3.67392 30 5V35C30 36.3261 30.5268 37.5979 31.4645 38.5355C32.4021 39.4732 33.6739 40 35 40C36.3261 40 37.5979 39.4732 38.5355 38.5355C39.4732 37.5979 40 36.3261 40 35V5C40 3.67392 39.4732 2.40215 38.5355 1.46447C37.5979 0.526784 36.3261 0 35 0V0ZM36.6667 35C36.6667 35.442 36.4911 35.866 36.1785 36.1785C35.866 36.4911 35.442 36.6667 35 36.6667C34.558 36.6667 34.134 36.4911 33.8215 36.1785C33.5089 35.866 33.3333 35.442 33.3333 35V5C33.3333 4.55797 33.5089 4.13405 33.8215 3.82149C34.134 3.50893 34.558 3.33333 35 3.33333C35.442 3.33333 35.866 3.50893 36.1785 3.82149C36.4911 4.13405 36.6667 4.55797 36.6667 5V35Z",
    fill: "#23AA59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.818 1.81802C32.6619 0.974106 33.8065 0.5 35 0.5C36.1935 0.5 37.3381 0.974106 38.182 1.81802C39.0259 2.66193 39.5 3.80653 39.5 5V35C39.5 36.1935 39.0259 37.3381 38.182 38.182C37.3381 39.0259 36.1935 39.5 35 39.5C33.8065 39.5 32.6619 39.0259 31.818 38.182C30.9741 37.3381 30.5 36.1935 30.5 35V5C30.5 3.80653 30.9741 2.66193 31.818 1.81802ZM36.5321 36.5321C36.9384 36.1257 37.1667 35.5746 37.1667 35V5C37.1667 4.42536 36.9384 3.87426 36.5321 3.46794C36.1257 3.06161 35.5746 2.83333 35 2.83333C34.4254 2.83333 33.8743 3.06161 33.4679 3.46794C33.0616 3.87426 32.8333 4.42536 32.8333 5V35C32.8333 35.5746 33.0616 36.1257 33.4679 36.5321C33.8743 36.9384 34.4254 37.1667 35 37.1667C35.5746 37.1667 36.1257 36.9384 36.5321 36.5321Z",
    stroke: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1459_1889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11C18.6739 11 17.4021 11.5268 16.4645 12.4645C15.5268 13.4021 15 14.6739 15 16V35C15 36.3261 15.5268 37.5979 16.4645 38.5355C17.4021 39.4732 18.6739 40 20 40C21.3261 40 22.5979 39.4732 23.5355 38.5355C24.4732 37.5979 25 36.3261 25 35V16C25 14.6739 24.4732 13.4021 23.5355 12.4645C22.5979 11.5268 21.3261 11 20 11ZM21.6667 35C21.6667 35.442 21.4911 35.866 21.1785 36.1785C20.866 36.4911 20.442 36.6667 20 36.6667C19.558 36.6667 19.134 36.4911 18.8215 36.1785C18.5089 35.866 18.3333 35.442 18.3333 35V16C18.3333 15.558 18.5089 15.134 18.8215 14.8215C19.134 14.5089 19.558 14.3333 20 14.3333C20.442 14.3333 20.866 14.5089 21.1785 14.8215C21.4911 15.134 21.6667 15.558 21.6667 16V35Z",
    fill: "#23AA59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.818 12.818C17.6619 11.9741 18.8065 11.5 20 11.5C21.1935 11.5 22.3381 11.9741 23.182 12.818C24.0259 13.6619 24.5 14.8065 24.5 16V35C24.5 36.1935 24.0259 37.3381 23.182 38.182C22.3381 39.0259 21.1935 39.5 20 39.5C18.8065 39.5 17.6619 39.0259 16.818 38.182C15.9741 37.3381 15.5 36.1935 15.5 35V16C15.5 14.8065 15.9741 13.6619 16.818 12.818ZM21.5321 36.5321C21.9384 36.1257 22.1667 35.5746 22.1667 35V16C22.1667 15.4254 21.9384 14.8743 21.5321 14.4679C21.1257 14.0616 20.5746 13.8333 20 13.8333C19.4254 13.8333 18.8743 14.0616 18.4679 14.4679C18.0616 14.8743 17.8333 15.4254 17.8333 16V35C17.8333 35.5746 18.0616 36.1257 18.4679 36.5321C18.8743 36.9384 19.4254 37.1667 20 37.1667C20.5746 37.1667 21.1257 36.9384 21.5321 36.5321Z",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83611 21.9617C2.68508 21.0184 3.82454 20.5 5 20.5C6.17546 20.5 7.31492 21.0184 8.16389 21.9617C9.01442 22.9067 9.5 24.1987 9.5 25.5556V34.4444C9.5 35.8013 9.01442 37.0933 8.16389 38.0383C7.31492 38.9816 6.17546 39.5 5 39.5C3.82454 39.5 2.68508 38.9816 1.83611 38.0383C0.985578 37.0933 0.5 35.8013 0.5 34.4444V25.5556C0.5 24.1987 0.985578 22.9067 1.83611 21.9617ZM6.55016 36.0884C6.94987 35.6443 7.16667 35.0522 7.16667 34.4444V25.5556C7.16667 24.9478 6.94987 24.3557 6.55016 23.9116C6.14889 23.4658 5.59265 23.2037 5 23.2037C4.40735 23.2037 3.85111 23.4658 3.44984 23.9116C3.05013 24.3557 2.83333 24.9478 2.83333 25.5556V34.4444C2.83333 35.0522 3.05013 35.6443 3.44984 36.0884C3.85111 36.5342 4.40735 36.7963 5 36.7963C5.59265 36.7963 6.14889 36.5342 6.55016 36.0884Z",
    fill: "#23AA59",
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1459_1889",
    x: 26,
    y: 0,
    width: 18,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1459_1889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1459_1889",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1459_1889",
    x: 11,
    y: 11,
    width: 18,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1459_1889"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1459_1889",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSignal);
export default __webpack_public_path__ + "static/media/powerSignal.4db4c44bc69718ef3105015ee77df873.svg";
export { ForwardRef as ReactComponent };